import { Glue42 } from "../../../glue";
import JumpListCategories from "./categories";
import jumpListManager from "./manager";

export default class JumpList implements Glue42.Windows.JumpList {

    private _categories: Glue42.Windows.JumpListCategoriesAPI;

    constructor(private windowId: string) {
        this._categories = new JumpListCategories(windowId);
    }

    get categories(): Glue42.Windows.JumpListCategoriesAPI {
        return this._categories;
    }

    public async isEnabled(): Promise<boolean> {
        const configuration = await jumpListManager.getJumpListSettings(this.windowId);
        return configuration.enabled;
    }

    public setEnabled(enabled: boolean): Promise<void> {
        return jumpListManager.setEnabled(this.windowId, enabled);
    }
}
